import React from 'react';
import DataTable from 'react-data-table-component';
import styled, { css } from 'styled-components';

const Table = ({
  data,
  columns,
  handleRowSelect,
  onRowClicked,
  className,
  selectableRowsComponent,
  selectableRows,
  progressComponent,
  progressPending,
  pointer,
  pagination,
  paginationServer,
  app,
  paginationTotalRows,
  onChangeRowsPerPage,
  onChangePage,
  border
}) => {
  const TableData = React.useMemo(() => data, [data]);
  const TableColumns = React.useMemo(() => columns, [columns]);
  const select = app ? selectableRows : null;


  return (
    <TableWrapper className={className} pointer={pointer} border={border}>
      <DataTable
        columns={TableColumns}
        data={TableData || []}
        onSelectedRowsChange={handleRowSelect}
        onRowClicked={onRowClicked}
        selectableRows={select}
        selectableRowsComponent={selectableRowsComponent}
        progressPending={progressPending}
        progressComponent={progressComponent}
        pagination={pagination}
        paginationServer={paginationServer}
        paginationTotalRows={paginationTotalRows}
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
      />
    </TableWrapper>
  );
};

export default Table;

const TableWrapper = styled.div`
  .rdt_ {
    &TableRow {
      height: 57px;
      border-bottom: 0.0852273px solid rgba(91, 91, 91, 0.4);
      border-top: 0;
      font-size: 12px;
      font-weight: 500;
      color: #11192A;
      cursor: ${({ pointer }) => (pointer ? 'pointer' : 'auto')};
      ${({ border }) =>
    !border &&
    css`
          padding: 15px;
      `};
    }
    &TableHeadRow {
      height: 55px;
      background-color: #EFEFEF;
      border-bottom: 0;
      padding: 15px;
      font-weight: 700;
      font-size: 12px;
      color: #11192A;
      ${({ border }) =>
    border &&
    css`
          border: 0.0852273px solid rgba(91, 91, 91, 0.4);
      `};
    }
    &TableCell{
      ${({ border }) =>
    border &&
    css`
          border-right: 0.0852273px solid rgba(91, 91, 91, 0.4);
      `};
    }
    &Pagination{
      justify-content: center;
    }
  }

  .fxSmWS {
    border: 1px solid #FFA500;
    padding: 5px 4px;
    color: #FFA500;
  }
  
  #pagination-previous-page,
  #pagination-next-page {
    border-radius: 3px;
    margin: 0 3px;
    border: 1px solid #DFE3E8
  }

  #pagination-first-page,
  #pagination-last-page {
    display: none;
  }
`;
